// Lee los módulos opcionales (features) desde la config de runtime (config.json),
// poblada por el plugin runtime-config en el singleton utils/runtime-config. Espejo
// de utils/services-enabled.js.
//
// Evaluación LAZY: se lee en cada llamada, NO en module-load — cuando este módulo se
// importa el config aún no está cargado (el fetch ocurre en el primer plugin).
//
// Opt-in: ausencia del bloque features, de la clave, o cualquier valor que no sea el
// booleano true, se interpreta como desactivado (coherente con el helper del applier).
//
// Uso:
//   import { isFeatureEnabled } from '~/utils/features-enabled';
//   if (isFeatureEnabled('sii')) { ... }

import { getRuntimeConfig } from "./runtime-config";

/**
 * @param {string} feature - clave de la feature (p.ej. 'sii').
 * @returns {boolean} true solo si config.features[feature] === true.
 */
export const isFeatureEnabled = (feature) => getRuntimeConfig()?.features?.[feature] === true;

const PAYROLL_IMPORT_MODES = ["off", "native", "external"];

/**
 * Modo de importación de nóminas del tenant. No es una feature booleana: el applier
 * emite config.features.payrollImport = { mode } con el modo ya resuelto.
 * @returns {'off'|'native'|'external'} el modo del config; 'off' si falta, no es un
 *   objeto o trae un valor desconocido.
 */
export const payrollImportMode = () => {
	const mode = getRuntimeConfig()?.features?.payrollImport?.mode;
	return PAYROLL_IMPORT_MODES.includes(mode) ? mode : "off";
};
